import { generateUUID } from "../../util";
import moment from "moment";

function randInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
}

function generateMessage() {
  const words = `
  Call me Ishmael. Some years ago—never mind how long precisely—having little or no money in my purse, and nothing particular to interest me on shore, I thought I would sail about a little and see the watery part of the world. It is a way I have of driving off the spleen and regulating the circulation. Whenever I find myself growing grim about the mouth; whenever it is a damp, drizzly November in my soul; whenever I find myself involuntarily pausing before coffin warehouses, and bringing up the rear of every funeral I meet; and especially whenever my hypos get such an upper hand of me, that it requires a strong moral principle to prevent me from deliberately stepping into the street, and methodically knocking people’s hats off—then, I account it high time to get to sea as soon as I can. This is my substitute for pistol and ball. With a philosophical flourish Cato throws himself upon his sword; I quietly take to the ship. There is nothing surprising in this. If they but knew it, almost all men in their degree, some time or other, cherish very nearly the same feelings towards the ocean with me.
  `;
  const wordArray = words.split(".");
  return wordArray[randInt(0, wordArray.length - 1)];
}

const generateAlerts = ({ numAlerts = 5 }) => {
  let alerts = [];
  let duration = randInt(3, 7);
  for (let i = 0; i < numAlerts; i++) {
    alerts.push({
      eventId: generateUUID(),
      pointId: generateUUID(),
      pointName: "Point" + randInt(0, 200),
      location: {
        siteName: "Site" + randInt(0, 200),
        siteId: generateUUID(),
        buildingName: "Building" + randInt(0, 200),
        buildingId: generateUUID(),
        floorName: "Floor" + randInt(0, 200),
        floorId: generateUUID(),
        spaceName: "Space" + randInt(0, 200),
        spaceId: generateUUID(),
        deviceName: "Device" + randInt(0, 200),
        deviceId: generateUUID(),
      },
      priority: randInt(0, 2),
      startTime: moment(new Date())
        .subtract(duration)
        .format("MMMM Do YYYY, h:mm:ss a"),
      endTime: moment(new Date()).format("MMMM Do YYYY, h:mm:ss a"),
      userAction: {
        time: "",
        user: "",
        // "seen" or not, defaults no
        action: "",
      },
      alarmMessage: generateMessage(),
      alertThreshold: "68° to 74°",
      currentValue: Math.random() < 0.5 ? randInt(62, 67) : randInt(75, 80),
      state: "active",
      acknowledged: false,
    });
  }
  return alerts;
};

export default generateAlerts;
